// Platform pulse (`/pulse`) — the aggregate sentiment map across all stories
// (TRIL-327). Full-bleed, system-themed; click a state to see the stories driving
// its sentiment.
import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';

import {
  PlatformSentimentMap,
  type PlatformData,
} from '../../components/SentimentMap/PlatformSentimentMap';
import { GET_PLATFORM_SENTIMENT_MAP_QUERY } from '../../graphql/resolvers/postQueries/getPlatformSentimentMap.gql';
import { detectSystemTheme } from '../../helpers/theme';
import '../Posts/SentimentMap/sentiment-map-page.scss';

function usePrefersDark(): boolean {
  const [dark, setDark] = useState(() => detectSystemTheme() === 'dark');
  useEffect(() => {
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const fn = (e: MediaQueryListEvent) => setDark(e.matches);
    mq.addEventListener('change', fn);
    return () => mq.removeEventListener('change', fn);
  }, []);
  return dark;
}

export default function PulsePage() {
  const navigate = useNavigate();
  const dark = usePrefersDark();
  const { data, loading } = useQuery(GET_PLATFORM_SENTIMENT_MAP_QUERY);

  const platform = (data?.platformSentimentMap ?? null) as unknown as PlatformData | null;

  return (
    <div className={`smap-page ${dark ? 'smap-page--dark' : 'smap-page--light'}`}>
      <button
        type="button"
        className="smap-page__close"
        onClick={() => navigate(-1)}
        aria-label="Close platform pulse"
      >
        ✕
      </button>
      <PlatformSentimentMap data={platform} loading={loading} dark={dark} />
    </div>
  );
}
